import React from 'react';
import PlusBusRow from './PlusBusRow';

const PlusBus = ({ originName, destinationName, terminals, ticketCount }) => {
  let plusBusRows = [];
  const {
    outwardPlusBusOrigin,
    outwardPlusBusDestination,
    returnPlusBusOrigin,
    returnPlusBusDestination
  } = terminals;

  if (outwardPlusBusOrigin || returnPlusBusDestination) {
    const originQuantity = (Boolean(outwardPlusBusOrigin) + Boolean(returnPlusBusDestination)) * ticketCount;
    plusBusRows.push(
      <PlusBusRow stationName={originName} quantity={originQuantity} />
    );
  }

  if (outwardPlusBusDestination || returnPlusBusOrigin) {
    const destinationQuantity = (Boolean(outwardPlusBusDestination) + Boolean(returnPlusBusOrigin)) * ticketCount;
    plusBusRows.push(
      <PlusBusRow stationName={destinationName} quantity={destinationQuantity} />
    );
  }

  return (
    <div className="otrl-jp__favourite-ticket__plusbus">
      {plusBusRows.map((row, i) => <React.Fragment key={i}>{row}</React.Fragment>)}
    </div>
  );
};

export default PlusBus;